import {
  IRecruiterSearchDTO,
  IRecruiterSearchFilterDTO,
  IRecruiterTeamNameAutoCompleteOption,
  ITeam,
  postAdvancedQuery,
} from 'wisestep-api';

export const getPostAdvancedQuery = async (queryText: string, size?: number) => {
  const query: IRecruiterSearchFilterDTO = {
    size: size ?? 10,
    sort: ['createdOn,DESC'],
    recruiterEmailPhrase: queryText,
    recruiterFirstNamePhrase: queryText,
    recruiterLastNamePhrase: queryText,
    page: 0,
    query: '',
  };
  const workspaceRecruitersResponse = await postAdvancedQuery(query);
  const workspaceRecruiters = workspaceRecruitersResponse.data;
  return workspaceRecruiters as IRecruiterSearchDTO[];
};

export const getKeys = (teamsResponse) =>
  Object.entries(teamsResponse).map(([key]) => (key as string) ?? []);

export const getValues = (teamsResponse) =>
  teamsResponse ? Object.entries(teamsResponse).map(([, value]) => value as string) : [];

export const getFilterEmails = (superList, list): string[] =>
  list?.map((obj) => {
    const parts = obj.split(' ');
    for (const part of parts) {
      if (part.includes('@') && part.includes('.')) {
        const email = part.replace(/[()]/g, '');
        return email;
      }
    }
  }) ?? [];

export const filterOptionsListByEmailAndGetSelectedEmails = (
  superList: IRecruiterTeamNameAutoCompleteOption[],
  selectedEmails: string[]
): string[] =>
  superList
    ?.filter((obj) => selectedEmails.some((value) => obj.email === value))
    ?.map((obj) => obj.email) ?? [];

export const getRecruiterEmails = (superList, list): string[] =>
  list.map((recruiterEmail) => {
    const recruiter = superList.find((recruiter) => recruiter.text === recruiterEmail);
    return recruiter?.email ?? recruiterEmail;
  });
export const getFilterIds = (superList, list): string[] =>
  superList?.filter((obj) => list.some((value) => obj.text === value))?.map((obj) => obj.id) ?? [];
export const getFilterObj = (superList, list): ITeam[] =>
  superList?.filter((obj) => list.some((value) => obj.text === value))?.map((obj) => obj) ?? [];
export const getRecruiterNameAndEmail = (recruiters) => {
  const finalResult =
    recruiters?.map(function (recruiter) {
      const name = recruiter?.userName;
      const text = `${name} (${recruiter.userId})`;

      return {
        text: text,
        email: recruiter.userId,
        id: recruiter.id,
        name: name,
      };
    }) || [];

  return finalResult as IRecruiterTeamNameAutoCompleteOption[];
};

export const formatTeams = (teams: ITeam[]): IRecruiterTeamNameAutoCompleteOption[] =>
  teams.map((team) => ({
    text: team.name ?? '',
    email: team.ownerEmail ?? '',
    id: team.id ?? '',
    name: team.name ?? '',
  }));

export const getRecruiterNameAndCompanyName = (recruiters) => {
  const finalResult: IRecruiterTeamNameAutoCompleteOption[] =
    recruiters?.map(function (recruiter) {
      const text = `${recruiter.name} (${recruiter.companyName})`;
      return {
        text: text,
        email: recruiter.email,
        id: recruiter.id,
        name: recruiters.name,
      };
    }) || [];

  return finalResult as IRecruiterTeamNameAutoCompleteOption[];
};
